module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAARCAYAAAACCvahAAABV0lEQVQ4jZXSvWqUURDG8d+ubxS0F0QC1rkAL0Cns7AQ7IydhYViiB+dEvAGFAslxWITRGxkC+FMaScYjFeg6SwUiY2auBZ7Eg4vmxgfOAxnmP+cZ4YzKKU8xVVTDfxbkxpHHa7hOjb+Az6HlQ7fMY6IzUOAIDO3cWeIPzh1WLDqJHa6evlVO46qpUmv+AeO4XVELGEbduFhjW/xpbppdRyf8LneBy18FCJidZbHzLyJnYh4WVNdC/+sRQ9xtvfyBAuYz8wzEbGM3y2sabI14/GvmMeRNrkLz1XbK/vYfoYPEXFrlu3+dvu6GxHfeqPsbflA9cA99Wdura7hIh5FxL2D4LkGCqyZfpwnWM7MS7gcEett/bCed5nZZeYbFLyIiNMRcRsn8BHvM/N5hdfRDUopW1jFIjaxGBEbM8Y4j5Hpssa4MiiljHEBNyLi8X47aJo8wH28+gsT6nHOzstzWAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/apps/57.png
// module id = 8inm
// module chunks = 0